import { ChooseDate } from 'app/src/components/ChooseDate';
import momentDefault from 'moment';
import PopOver from 'app/scripts/views/lib/pop-over.coffee';
import React from 'react';
import Util from 'app/scripts/lib/util/index.coffee';
import { trackUe, Noun, Verb } from '@trello/analytics';
import { AdvancedChecklistsBetaInfo } from './advanced-checklists-beta-info';

interface OptionsV2 {
  title: string;
  trackingMethod: string;
  // In V2, we can set the date directly, rather than embedding it in the
  // checkItem name.
  getInitialDate: () => string | undefined;
  setDate: (value: Date | null) => void;
  moment?: typeof momentDefault.utc;
}

export function toggleDatePopoverV2({
  title,
  trackingMethod,
  getInitialDate,
  setDate,
  moment = momentDefault,
}: OptionsV2) {
  return function toggle(e: MouseEvent) {
    Util.stop(e);

    const dateString = getInitialDate() || undefined;
    const dateInitial = dateString ? moment(dateString).toDate() : undefined;

    trackUe(
      Noun.CARD_DETAIL,
      Verb.OPENS,
      dateInitial ? Noun.CHANGE_DUE_DATE_PICKER : Noun.DUE_DATE_PICKER,
      'on checkitem',
      '',
      trackingMethod,
    );

    PopOver.toggle({
      elem: e.currentTarget,
      getViewTitle: () => title,
      keepEdits: true,
      reactElement: (
        <React.Fragment key="choose-date">
          <ChooseDate
            dateInitial={dateInitial}
            onSelect={(date) => {
              PopOver.hide();

              // Since the user doesn't pick a time, and the time isn't visible
              // shown, set the time to 11:59pm. That way, the checkItem won't
              // appear overdue until the next day.
              const endOfDay = date
                ? moment(date).hour(23).minute(59).toDate()
                : null;

              setDate(endOfDay);
            }}
          />
          <AdvancedChecklistsBetaInfo />
        </React.Fragment>
      ),
    });
  };
}
